// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"34dd1ebe","498":"18dd6c25","513":"02e8b462","787":"11a7e7b0"}[chunkId] + ".chunk.js";
};